{
  "APP_NAME": "Toll Management",
  "My account": "Minha conta",
  "Users": "Usuários",
  "All": "Todas",
  "Paid": "Pagas",
  "Pending": "Pendentes",
  "Confirm": "Confirmar",
  "Include user": "Incluir usuário",
  "Include": "Adicionar",
  "Change data": "Alterar dados",
  "Change password": "Alterar senha",
  "My account/Change data": "Minha conta/Alterar dados",
  "My account/Change password": "Minha conta/Alterar senha",
  "Name": "Nome",
  "Download ticket": "Baixar boleto",
  "CPF": "CPF",
  "E-mail": "E-mail",
  "Phone": "Telefone",
  "Cancel": "Cancelar",
  "Continue": "Continuar",
  "Enter your current password": "Digite sua senha atual",
  "Enter your new password": "Digite sua nova senha",
  "Confirm your new password": "Confirme sua nova senha",
  "Account Type": "Tipo de conta",
  "Vehicle Type": "Tipo de veículo",
  "Current toll ticket balance": "Saldo atual de vale pedágio",
  "Select": "Selecionar",
  "Selectt": "Selecione",
  "CPF is required": "CPF é obrigatório",
  "Name is required": "Nome é obrigatório",
  "Phone is required": "Telefone é obrigatório",
  "E-mail is required": "E-mail é obrigatório",
  "Field is required": "Campo obrigatório",
  "Passwords do not match": "Senhas não conferem",
  "Password must be at least 8 characters": "A senha deve ter pelo menos 8 caracteres",
  "Password must be at least one letter in upper case": "A senha deve ter ao menos uma letra maiúscula",
  "Password must be at least one letter in lower case": "A senha deve ter ao menos uma letra minúscula",
  "View user": "Visualizar usuário",
  "Change profile": "Alterar perfil",
  "Lock user": "Bloquear usuário",
  "Unlock user": "Desbloquear usuário",
  "Profile permissions": "Permissões de perfil",
  "Loading...": "Carregando...",
  "Download in progress...": "Download em andamento...",
  "Vehicles": "Veículos",
  "General": "Geral",
  "Extract": "Extrato",
  "Tickets": "Passagens",
  "Vehicle": "Veículo",
  "Vehicle balance": "Saldo dos veículos",
  "Vehicle + actions": "Veículo + ações",
  "My vehicles": "Meus veículos",
  "Order detail": "Detalhe do pedido",
  "back to orders": "voltar para pedidos",
  "Request:": "Pedido:",
  "New request": "Novo pedido",
  "My requests": "Meus pedidos",
  "Balance vpr": "Saldo de VPR por veículos",
  "Credit received": "Créditos recebidos",
  "consolidated": "consolidado",
  "My bills": "Faturas",
  "Bills": "Faturas",
  "Last bills": "Últimas faturas",
  "My tickets": "Minhas passagens",
  "New vehicle": "Novo veículo",
  "Import vehicles": "Importar veículos",
  "Import spreadsheet": "Importar planilha",
  "Search": "Buscar",
  "Wait": "Por favor, aguarde!",
  "Nickname": "Apelido",
  "Nickname:": "Apelido:",
  "Type": "Tipo",
  "Type:": "Tipo:",
  "Type*": "Tipo*",
  "Number of Axis": "Nº de Eixos",
  "Number of Axis:": "Nº de Eixos:",
  "Axis": "Eixos",
  "Axis*": "Eixos*",
  "Hierarchy": "Hierarquia",
  "Hierarchy:": "Hierarquia:",
  "Available groups": "Grupos disponíveis",
  "My hierarchies": "Minhas hierarquias",
  "Services": "Serviços",
  "tickets and chargebacks": "Passagens e estornos",
  "Aggregate": "Agregado",
  "Status": "Status",
  "Reason is required": "Motivo é obrigatório",
  "Tag": "Tag",
  "Activation": "Ativação",
  "Yes": "Sim",
  "No": "Não",
  "Select a reason": "Selecione um motivo",
  "Confirm cancellation": "Confirmar cancelamento",
  "Tag canceled": "Tag cancelada",
  "Tag canceled:": "Tag cancelada:",
  "Home": "Home",
  "Login": "Login",
  "Logout": "Logout",
  "Password": "Senha",
  "Version": "Versão",
  "Board": "Placa",
  "Board:": "Placa:",
  "Board*": "Placa*",
  "Brand": "Marca",
  "Brand:": "Marca:",
  "Brand*": "Marca*",
  "Edit": "Editar",
  "Replace tag": "Substituir tag",
  "Replaced tag": "TAG substituída",
  "History": "Histórico",
  "Group Hierarchy": "Agrupar hierarquia",
  "Delete": "Excluir",
  "Delete vehicle": "Excluir veículo",
  "Block tag": "Bloquear tag",
  "Unblock tag": "Desbloquear tag",
  "Unbloqued tag": "Tag desbloqueada",
  "Cancel tag": "Cancelar tag",
  "Cancel active tag": "Cancelar tag ativa",
  "Lines amount": "Quantidade de linhas",
  "Logistic Partner": "Parceiro logístico",
  "Fill out the form to register a new vehicle:": "Preencha o formulário para cadastrar um novo veículo:",
  "Include vehicle": "Incluir veículo",
  "Board is required": "Placa é obrigatório",
  "Type is required": "Tipo é obrigatório",
  "Brand is required": "Marca é obrigatório",
  "Model is required": "Modelo é obrigatório",
  "Axis is required": "Eixos é obrigatório",
  "Nickname is required": "Apelido é obrigatório",
  "Hierarchy is required": "Hierarquia é obrigatório",
  "The driver is aggregated": "Motorista é agregado?",
  "RNTRC aggregate": "RNTRC do agregado",
  "RNTRC aggregate:": "RNTRC do agregado:",
  "CPF/CNPJ aggregate": "CPF/CNPJ do agregado",
  "CPF/CNPJ aggregate:": "CPF/CNPJ do agregado:",
  "CNPJ/CPF is required": "CNPJ/CPF é obrigatório",
  "RNTRC is required": "RNTRC é obrigatório",
  "Registers": "Cadastrados",
  "Without tag registered": "Sem tag cadastrada",
  "Activated Tag": "Tag ativada",
  "With active tag": "Com tag ativa",
  "With lock tag": "Com tag bloqueada",
  "Excluded vehicles": "Excluídos",
  "Edit vehicle": "Editar veículo",
  "Confirm edit": "Confirmar edição",
  "Back to editing": "Voltar para a edição",
  "Change data of vehicle with license plate:": "Alterar dados do veículo com placa:",
  "Are you sure you want to change the number of axes?": "Tem certeza que deseja alterar a quantidade de eixos?",
  "Linked tag": "Tag vinculada",
  "Select which menu you want to access:": "Selecione qual menu você deseja acessar:",
  "Availables options": "Opções disponíveis",
  "Reports": "Relatórios",
  "Attendance": "Atendimento",
  "Financial": "Financeiro",
  "active": "ativar",
  "No tag": "Sem tag",
  "No result for this search": "Nenhum resultado para esta pesquisa",
  "No sale for this date": "Nenhuma venda encontrada do dia",
  "No vehicle found": "Não há veículo encontrado",
  "No file found": "Nenhum arquivo encontrado",
  "Available Vehicles": "Veículos Disponíveis",
  "Available Tags": "Tags Disponíveis",
  "Type of service": "Tipo de serviço",
  "Add New Tag": "Incluir nova TAG",
  "Vehicle transferred": "Veículo transferido",
  "Choice": "Escolha",
  "Edit contract name": "Editar nome do contrato",
  "Select contracts": "Selecionar contrato",
  "Client query": "Consulta de cliente",
  "vehicle, board, brand...": "veículo, placa, marca...",
  "username, filename...": "usuário, nome do arquivo...",
  "Enter CPF/CNPJ or License Plate to search for the customer": "Insira o CPF/CNPJ ou a Placa para pesquisar o cliente",
  "Enter CPF/CNPJ to search for the customer": "Insira o CPF/CNPJ para pesquisar o cliente",
  "CPF or CNPJ": "CPF ou CNPJ",
  "Found contracts for the CPF": "Encontrado contratos para o CPF",
  "Availables contracts": "Contratos disponíveis",
  "Available contract": "Contrato disponível",
  "Call center": "Central de atendimento",
  "My business": "Minha empresa",
  "Exit": "Sair",
  "Change contract": "Trocar contrato",
  "Consult invoices": "consultar faturas",
  "Invoices": "Faturas",
  "Consult orders": "consultar pedidos",
  "Consult vehicles": "consultar veículos",
  "Enable tags": "Ativar tags",
  "Enable tag": "Ativar tag",
  "Last order": "Último pedido",
  "Tags": "Tags",
  "Transaction Details": "Detalhes de transações",
  "Your invoice is closed and waiting payment.": "Sua fatura está fechada e aguardando pagamento.",
  "Your invoice is open.": "Sua fatura está aberta.",
  "Your invoice is in closing.": "Sua fatura está em fechamento.",
  "Your invoice is paid.": "Sua fatura está paga.",
  "Your invoice is paying.": "Sua fatura está a pagar.",
  "Your invoice is late.": "Sua fatura está atrasada.",
  "To pay": "A pagar",
  "Track": "rastrear",
  "Shipped to carrier": "Enviado para Transportadora",
  "On carriage": "Em transporte",
  "Transfer vehicle": "Transferir veículo",
  "Order delivered": "Pedido entregue",
  "registered vehicles": "veículos cadastrados",
  "registered vehicle": "veículo cadastrado",
  "with active tag": "com tag ativa",
  "with active tags": "com tags ativas",
  "no tag": "sem tag",
  "no tags": "sem tags",
  "Availables": "Disponíveis",
  "Total tags:": "Total de tags:",
  "Active": "Ativas",
  "Blocked": "Bloqueadas",
  "Closed": "Fechado",
  "Close": "Fechar",
  "Open": "Aberto",
  "Closure": "Fechamento",
  "Paid out": "Pago",
  "Payable": "A Pagar",
  "Late": "Atrasado",
  "you don't have registered vehicles yet.": "você ainda não possui veículos registrados.",
  "Waiting for client confirmation": "Aguardando confirmação do cliente",
  "confirm receipt": "confirmar recebimento",
  "Order received": "Pedido recebido",
  "Informed customer has no contract": "Cliente informado não possui contrato",
  "Custumer not found for the informed License Plate": "Cliente não encontrado para a placa informada",
  "Model": "Modelo",
  "Model:": "Modelo:",
  "You do not have permission to access": "Você não tem permissão para acessar",
  "Unable to load the information": "Não foi possível carregar as informações",
  "Document or License Plate is required": "Documento ou placa é obrigatório",
  "Document is required": "Documento é obrigatório",
  "Tags received from OSA": "Tags recebidas da OSA",
  "Manufacturing date and time": "Data e hora da fabricação",
  "Tag number": "Número da tag",
  "OBUID": "OBUID",
  "Lot number": "Número do lote",
  "Export": "Exportar",
  "Tag number or lot": "Número de tag ou lote",
  "Filters": "Filtros",
  "Orders": "Pedidos",
  "Contractual alteration": "Alteração contratual",
  "File import": "Importação de arquivos",
  "Prepaid sales report": "Relatório de vendas pré-pago",
  "Sales report": "Relatório de vendas",
  "Contracted limit change": "Alteração de limite contratado",
  "Financial lock and unlock": "Bloqueio e desbloqueio financeiro",
  "Date": "Data",
  "Order number": "Número de pedido",
  "Company name": "Razão social",
  "Amount tags": "Quantidade de tags",
  "Protocol": "Protocolo",
  "Actions": "Ações",
  "My orders": "Meus pedidos",
  "Separate order": "Separar pedido",
  "Report tracking code": "Informar código de rastreamento",
  "Tracking code": "Código de rastreio",
  "Tracking code is required": "Código de rastreio é obrigatório",
  "Tracking code is invalid": "Código de rastreio é inválido",
  "Partner is required": "Parceiro é obrigatório",
  "Report tracking": "Informar rastreamento",
  "Serial number is required": "Número de serial obrigatório",
  "Complete": "Concluir",
  "Commercial conditions": "Condições comerciais",
  "Consult details": "Consultar detalhes",
  "Number of tags": "Quantidade de tags",
  "Requested by client": "Solicitadas pelo cliente",
  "Added to order": "Adicionadas ao pedido",
  "Edit inclusions": "Editar inclusões",
  "Freight": "Frete",
  "Tag value": "Valor das tags",
  "Responsible for receiving the order": "Responsável pelo recebimento do pedido",
  "Total order amount": "Valor total do pedido",
  "Finalize separation": "Finalizar separação",
  "Delivery address": "Endereço de entrega",
  "Track order": "Rastrear pedido",
  "Copy tracking code": "Copiar código de rastreio",
  "Info tracking": "Código de rastreamento emitido pelo parceiro logístico",
  "Enter your order tracking code": "Digite o código de rastreio de seu pedido",
  "Tracking code included": "Código de rastreio incluído",
  "Generating files": "Gerando arquivos..",
  "See tracking": "Ver rastreamento",
  "Import date and time": "Data e hora da importação",
  "Responsible user": "Usuário responsável",
  "File name": "Nome do arquivo",
  "File type": "Tipo de arquivo",
  "Action": "Ação",
  "Try again": "Tentar novamente",
  "Import files": "Importar arquivos",
  "Consult reason": "Consultar motivo",
  "RPS code, Authorization code...": "Código de RPS, Código de autorização...",
  "Sale date": "Data de venda",
  "Payment date": "Data do pagamento",
  "Gross value": "Valor bruto",
  "Fee value": "Valor da taxa",
  "Net value": "Valor líquido",
  "Transaction type": "Tipo de transação",
  "Authorization code": "Autorização",
  "Cancel Sale": "Cancelar venda",
  "Financial block": "Bloqueio financeiro",
  "Contract": "Contrato",
  "Delivery Addresses": "Endereços para entrega",
  "Registration": "Cadastro",
  "Management": "Gerenciamento",
  "Representatives and attorneys": "Representantes e procuradores",
  "Contract users": "Usuários do contrato",
  "bonus tags": "bonificadas",
  "In stock": "Em estoque",
  "Reinclude in the fleet": "Reincluir na frota",
  "Reinclude the vehicle": "Reincluir o veículo",
  "Register new address": "Cadastrar novo endereço",
  "Register delivery address": "Cadastrar endereço de entrega",
  "Alter delivery address": "Alterar endereço de entrega",
  "Delete delivery address": "Excluir endereço de entrega",
  "Fleet Indicators": "Indicadores de Frota",
  "Fleet Panel": "Painel de Gestão",
  "Document Number": "CNPJ",
  "Card": "Cartão",
  "Account Balance": "Saldo Disponível Atual",
  "transactionDate": "Data da transação",
  "expectedClearingDate": "Data do pagamento",
  "transactionType": "Tipo da transação",
  "transactionTypeDescription": "Tipo da transação",
  "authorization": "Autorização",
  "[Authorization]": "Autorização",
  "nsu": "NSU",
  "netAmount": "Valor líquido",
  "rechargeFeeAmount": "Taxa",
  "transactionStatus": "Status Transação",
  "transactionStatusChangeDate": "Atualização de Status",
  "NSU, Athorization ou Document Number": "NSU, Autorização ou CNPJ",
  "Prepaid": "Pré-pago",
  "Transaction period": "Período de transação",
  "Range of values": "Faixa de valores",
  "Payment period": "Período de pagamento",
  "Select the period": "Selecione o período",
  "Apply filters": "Aplicar filtros",
  "Reset filters": "Limpar filtros",
  "AutomaticRecharge": "Recarga Automática",
  "PrepaidActiveTagMonthlyFee": "MENSALIDADE TAG ATIVA - LICENÇA DE SOFTWARE PRÉ-PAGO",
  "TagRequest": "Pedido de Tag",
  "SingleRecharge": "Recarga avulsa",
  "MonthlyFee": "Mensalidade",
  "RechargeFee": "Taxa de recarga",
  "PrepaidInactiveTagMonthlyFee": "MENSALIDADE TAG EM ESTOQUE - LICENÇA DE SOFTWARE PRÉ-PAGO",
  "No Transactions Found": "Nenhuma transação encontrada",
  "Transaction Conciliation": "Conciliação de Transação",
  "registrationDate": "Data do processamento",
  "guidTransactionId": "Guid",
  "stepTransaction": "Status",
  "errorDescriptionPT": "Motivo da recusa",
  "Select how you want to search for the customer": "Selecione como deseja buscar pelo cliente",
  "Type to search": "Digite para buscar",
  "is required": "é obrigatório",
  "Document Number ou Athorization Code": "CNPJ ou código de autorização",
  "Card Holder": "Titular",
  "chargebackDate": "Data do Chargeback",
  "documentNumber": "CNPJ",
  "validationDeadlineDate": "Prazo para Validação",
  "totalAmount": "Valor total",
  "Prepaid chargeback report": "Relatório de chargeback",
  "Customer": "Cliente",
  "chargebackStatus": "Status",
  "No vehicle found using the searching criteria": "Por favor, verifique se digitou corretamente ou tente novamente com outra informação válida.",
  "Manual Payment Recomposition": "Baixa de Pagamento Manual",
  "Protocol is required and numeric": "Protocolo é obrigatório e numérico",
  "No invoice was found for this contract":"Não foi encontrada nenhuma fatura para este contrato.",
  "Recharge": "Recargas",
  "Credit card transactions": "Transações de cartão de crédito",
  "rechargeFee" : "Taxa Cobrada",
  "administrationFee": "Taxa MDR",
  "statusNd": "Status ND",
  "CreditCardBrand": "Bandeira",
  "Access contract": "Acessar contrato",
  "Logistics": "Logística",
  "Logistics stock": "Estoque logístico",
  "Tag orders - Customer": "Pedidos de tag - Cliente",
  "Contract Management": "Gestão de contratos",
  "Change postpaid credit limit": "Alterar limite de crédito pós-pago",
  "Financial postpaid block": "Bloqueio financeiro pós-pago",
  "Financial blocking and unblocking": "Bloqueio e desbloqueio financeiro",
  "Main menu": "Menu inicial",
  "Toll Voucher": "Vale Pedágio",
  "Fleet": "Frota",
  "Transaction conciliation": "Conciliação de transação",
  "No records found": "Nenhum registro encontrado",
  "Home Page": "Página Inicial",
  "Access Management": "Gestão de acessos",
  "Relationship consultant": "Consultor de relacionamento",
  "Consultant register": "Cadastrar consultor",
  "Relationship consultant register": "Cadastro de consultor de relacionamento",
  "Consultant view":"Visualizar Consultor",
  "Partners Transfer Conciliation": "Conciliação de repasse de parceiros",
  "Holidays calendar":"Calendário de feriados",
  "Expired Toll Voucher Trips": "Viagens vale-pedágio expiradas",
  "No trips found": "Nenhuma viagem encontrada.",
  "Please check that you typed it correctly or try again with another valid information.":"Por favor, verifique se digitou corretamente ou tente novamente com outra informação válida.",
  "Insurance Glass": "Seguro de Vidros",
  "Insurance Glass Management": "Gerenciar Seguro de Vidros",
  "Download active insurance glass report": "Baixar relatório de clientes ativos",
  "Clients": "Clientes"
}
